import {
  CategoryDisplayName,
  getCategoriesByOrder,
} from '@oxappsec/ox-consolidated-categories';
import { createSimpleAsyncAction } from 'async-utils';
import { snapshot } from 'valtio';
import { calcDateRange } from '../../../app/store-actions/top-bar-store-actions';
import TopBarStore from '../../../app/stores/top-bar-store';
import { getAppOwnersStore } from '../../../application-owners/api/applications-owners-api';
import { FilterTypeToFilter } from '../../../common/filters-utils/filters-utils';
import InventoryFiltersStore from '../../../dashboard-inventory/stores/inventory-filters-store';
import ScanStore from '../../../new-scan/store/scan-store';
import issuesService from '../../common/services';
import { LoadIssuesParams } from '../../common/types/issues-types';
import {
  setCategoriesFilters,
  setFilterBy,
  setStoreTopIssues,
  setTopIssuesCategory,
  setTotalIssues,
} from '../store-actions/top-issues-store-actions';
import {
  default as topIssuesStore,
  default as TopIssuesStore,
} from '../stores/top-issues-store';

export const loadTopIssues = createSimpleAsyncAction(
  async (params?: LoadIssuesParams) => {
    const { cache = false, limit = 5 } = params || {};
    const { dateRange } = snapshot(TopBarStore);
    const { displaySelectedAppOwners } = getAppOwnersStore();
    const [from, to] = calcDateRange(dateRange);
    const { filters } = snapshot(InventoryFiltersStore);
    const { scanID, realScanId, isDemoEnabled } = snapshot(ScanStore);
    const results = await issuesService.getIssues.execute(
      {
        limit,
        filters: topIssuesStore.filterBy,
        owners: displaySelectedAppOwners,
        inventoryFilters: filters,
        ...(realScanId ? { scanID: realScanId } : scanID && { scanID }),
        dateRange: {
          from,
          to,
        },
      },
      isDemoEnabled,
      cache,
    );

    if (results) {
      setStoreTopIssues(results.issues);
      setTopIssuesCategory(results.issues);
      setTotalIssues(results.totalIssues);
    }
  },
  {
    asyncState: TopIssuesStore.loadingIssues,
    errorMessage: 'Failed to load issues',
  },
);

export const loadCategories = async (
  cache: boolean = true,
  limit: number = 20,
) => {
  const { displaySelectedAppOwners } = getAppOwnersStore();
  const { dateRange } = snapshot(TopBarStore);
  const [from, to] = calcDateRange(dateRange);
  const { filters } = snapshot(InventoryFiltersStore);
  const { isDemoEnabled } = snapshot(ScanStore);
  const results = await issuesService.getIssuesFilters.execute(
    {
      limit,
      owners: displaySelectedAppOwners,
      inventoryFilters: filters,
      dateRange: {
        from,
        to,
      },
    },
    cache,
    isDemoEnabled,
  );
  if (results) {
    const categories = results.categories?.map(category => {
      return category.label;
    });
    const categoriesOrder = getCategoriesByOrder();
    let categoryOrderName: string[] = [];
    categoriesOrder.map(category =>
      categoryOrderName.push(category.displayName),
    );
    categories?.sort(
      (a, b) => categoryOrderName.indexOf(a) - categoryOrderName.indexOf(b),
    );
    setCategoriesFilters(categories as CategoryDisplayName[]);
  }
};

export const handleFilterBy = (
  filterType?: FilterTypeToFilter,
  filterBy?: number,
) => {
  setFilterBy(filterType, `${filterBy}`);
  loadTopIssues();
  loadCategories();
};
